<template>
  <slick ref="slick"
         :options="sliderOptions"
         class="slider"
         @init="onInit"
         @afterChange="onAfterChange">
    <div v-for="(element, key) in elements"
         :key="key"
         class="disInlB">
      <component :is="cardType"
                 v-if="!element.isAdd"
                 :element="element"
                 :type="type" />
    </div>
  </slick>
</template>
<script>
import Slick from 'vue-slick'
import GalleryCard from '@/components/gallery-card/GalleryCard.vue'
import FullScreenGalleryCard from '@/components/full-screen-gallery-card/fullScreenGalleryCard.vue'
import FullScreenSliderCard from '@/components/full-screen-slider-card/fullScreenSliderCard.vue'
import { SliderConfs } from '@/components/slider/sliderConstants.js'

export default {
  components: {
    GalleryCard,
    FullScreenGalleryCard,
    FullScreenSliderCard,
    Slick
  },
  props: {
    elements: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    elementInitId: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    cardType() {
      if (this.type === 'artist' || this.type === 'venue') {
        return `artist-venue-card`
      } else {
        return `${this.type}-card`
      }
    },
    sliderOptions() {
      if (this.type === 'gallery') {
        return SliderConfs.CARD_SLIDER_CONF
      } else if (this.type === 'full-screen-gallery') {
        return SliderConfs.GALLERY_FULL_SCREEN_SLIDER_CONF
      }
      return {}
    }
  },
  watch: {
    elements: function(val) {
      this.$refs.slick.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
      })
    }
  },
  methods: {
    onInit(event, slick) {
      if (this.type === 'full-screen-gallery') {
        var position = this.elements.findIndex(element => {
          return element.id === this.elementInitId
        })
        slick.slickGoTo(position)
        if (
          this.elements[position] &&
          this.elements[position].type &&
          this.elements[position].type === 1
        ) {
          this.$root.$emit(`startVideo${this.elements[position].id}`)
        }
      }
    },
    onAfterChange(event, slick) {
      if (this.type === 'full-screen-gallery') {
        this.$root.$emit('slideChange')
      }
    },
    emptySliderAds(event) {
      var elements = this.elements.filter(element => {
        return (
          element.values &&
          element.values.wegow_position === event.ad.wegow_position
        )
      })
      elements.forEach(element => {
        var selector = document.querySelector(`#${element.values.id}`)
        if (selector && selector.closest && selector.closest('.slick-slide'))
          this.$refs.slick.remove(
            parseInt(
              selector.closest('.slick-slide').getAttribute('data-slick-index')
            )
          )
      })
      this.$refs.slick.reSlick()
    }
  }
}
</script>
